import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { defaultLanguage } from "./utils/constants";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json"
    },
    detection: {
      order: ["path"],
      lookupFromPathIndex: 0
    },
    fallbackLng: defaultLanguage,
    debug: true,
    interpolation: {
      escapeValue: false // need this for separate files
    }
  });

export default i18n;
